import { render, staticRenderFns } from "./AdminArea.vue?vue&type=template&id=cc93645c&scoped=true&"
import script from "./AdminArea.vue?vue&type=script&lang=js&"
export * from "./AdminArea.vue?vue&type=script&lang=js&"
import style0 from "./AdminArea.vue?vue&type=style&index=0&id=cc93645c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc93645c",
  null
  
)

export default component.exports